<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view/>
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
    <modal
      :show.sync="showAlert"
      :gradient="alert.type"
      :modal-classes="'modal-' + alert.type + ' modal-dialog-centered'"
    >
      <h6 slot="header" class="modal-title">{{ alert.title }}</h6>
      <div class="py-3 text-center">
        <h4 class="heading mt-4">{{ alert.description }}</h4>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          @click="showAlert = false"
          text-color="white"
          class="ml-auto"
        >
          Fechar
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
  import { FadeTransition } from 'vue2-transitions'
  import Modal from '@/components/Modal.vue'
  import  EventBus from './event-bus'
  export default {
    components: {
      FadeTransition,
      Modal
    },
    data(){
      return {
        showAlert: false,
        alert:{
          title: '',
          type: '',
          description:'',
        }
      }
    },
    mounted() {
      const self = this
      EventBus.$on('show-alert', alert => {
        self.alert = alert
        self.showAlert = true
      })
    }
  }
</script>
